import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import nl from "./locales/nl.json";
import en from "./locales/en.json";
import fr from "./locales/fr.json";

const STORED = (typeof window !== "undefined" && localStorage.getItem("jr_locale")) || "nl";

i18n
    .use(initReactI18next)
    .init({
        resources: {
            nl: { translation: nl },
            en: { translation: en },
            fr: { translation: fr },
        },
        lng: STORED,
        fallbackLng: "en",
        interpolation: { escapeValue: false },
    });

export function setLocale(lng) {
    localStorage.setItem("jr_locale", lng);
    i18n.changeLanguage(lng);
}

export default i18n;
